import { MouseEventHandler, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';

import Divider from '@mui/material/Divider';

import AgTypography from '../../../Styles/AgTypography';
import { AgColor } from '../../../Styles/AgColor';

export interface AgMemberProfileCardProps {
  width?: string;
  memberProfile?: string | number;
  memberID?: string | number;
  managedBy?: string;
  memberOf?: string;
  inactive?: boolean;
  isSelected?: boolean;
  onClick?: MouseEventHandler;
}

const AgMemberProfileCard = (
  {
    width,
    memberProfile,
    memberID,
    managedBy,
    memberOf,
    inactive,
    isSelected,
    onClick
  }: AgMemberProfileCardProps
) => {
  const messages = useIntl().formatMessage;
  const location = useLocation();
  const isStaff = /^\/(add_)?staff(\/\d+)?$/i.test(location.pathname) ||
    /^\/account\/profile(\/\d+)?$/i.test(location.pathname);

  const profileName = isStaff ? 'STAFF_PROFILE' : 'MEMBER_PROFILE';
  const profileID = isStaff ? 'STAFF_ID' : 'MEMBER_ID';
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  let accountFlag = '';
  switch (memberProfile) {
    case 1:
      accountFlag = messages({ id: 'USER_TYPE_AGUNITY' });
      break;
    case 2:
      accountFlag = messages({ id: 'USER_TYPE_DEMO' });
      break;
  }

  return (
    <AgTypography
      style={{
        width: width ?? '216px',
        boxSizing: 'border-box',
        padding: '8px 12px 12px 12px',
        display: 'grid',
        gap: '16px',
        borderRadius: '8px',
        cursor: 'pointer',
        outline: isHovered || isSelected
          ? `2px solid ${AgColor.secondaryDark}`
          : `1px solid ${AgColor.grey3}`
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
    >

      <AgTypography
        style={{
          display: 'grid',
          gap: '8px'
        }}
      >
        <AgTypography
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <AgTypography
            contentStyle={'AP.H5.Bold'}
            style={{
              color: inactive
                ? AgColor.errorMain
                : isHovered || isSelected
                  ? AgColor.secondaryDark
                  : AgColor.grey6
            }}
          >
            {messages({ id: profileName })}
            {inactive && (' - ' + messages({ id: 'MEMBER_PERSONAL_DETAILS_INACTIVE' }))}
          </AgTypography>
          <AgTypography
            message={accountFlag}
            contentStyle={'AP.H5.Bold'}
            style={{
              color: AgColor.primaryLight
            }}
          />
        </AgTypography>
        <AgTypography
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <AgTypography
            message={messages({ id: profileID })}
            contentStyle={'AP.H5.Bold'}
            style={{
              color: AgColor.grey6
            }}
          />
          <AgTypography
            message={`${isStaff ? '#s' : '#m'}${memberID}`}
            contentStyle={'AP.H5.Bold'}
            style={{
              color: AgColor.grey9
            }}
          />
        </AgTypography>

        <Divider sx={{ margin: '4px 0', color: AgColor.grey4 }} />

        {!isStaff ? <AgTypography>
          <AgTypography
            style={{
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <AgTypography
              message={messages({ id: 'MEMBER_MANAGED_BY' })}
              contentStyle={'AP.H5.Bold'}
              style={{
                color: AgColor.grey6
              }}
            />
            <AgTypography
              message={managedBy}
              contentStyle={'AP.H5.Bold'}
              style={{
                color: AgColor.grey9
              }}
            />
          </AgTypography>
          <AgTypography
            style={{
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <AgTypography
              message={messages({ id: 'MEMBER_OF' })}
              contentStyle={'AP.H5.Bold'}
              style={{
                color: AgColor.grey6
              }}
            />
            <AgTypography
              message={memberOf}
              contentStyle={'AP.H5.Bold'}
              style={{
                color: AgColor.grey9
              }}
            />
          </AgTypography>
        </AgTypography> : <AgTypography
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <AgTypography
            message={messages({ id: 'STAFF_WORKS_AT' })}
            contentStyle={'AP.H5.Bold'}
            style={{
              color: AgColor.grey6
            }}
          />
          <AgTypography
            message={managedBy}
            contentStyle={'AP.H5.Bold'}
            style={{
              color: AgColor.grey9
            }}
          />
        </AgTypography>}

      </AgTypography>
    </AgTypography>
  );
};

export default AgMemberProfileCard;